import { localStorageGet, LocalStorageKey, localStorageSet } from '../data/client_local_storage.ts';

const LogMessageLimit = 300;

function recordLogMessage(args: any[]) {
  const date = new Date().toLocaleString();
  const message = args.reduce((result, value) => result + value, '');
  const dateAndMessage = date + ': ' + message;
  const previousLogMessages = localStorageGet(LocalStorageKey.Logging);
  const logMessages = [dateAndMessage, ...previousLogMessages];
  logMessages.length = Math.min(logMessages.length, LogMessageLimit);
  localStorageSet(LocalStorageKey.Logging, logMessages);
}

export function recordConsoleLog() {
  const log = console.log.bind(console);
  console.log = (...args) => {
    log(...args);
    recordLogMessage(args);
  };

  const error = console.error.bind(console);
  console.error = (...args) => {
    args = ['ERROR: ', ...args];
    error(...args);
    recordLogMessage(args);
  };
}
